jQuery(function($) {
    if ($('.notification-banner').length == 0) {
        return;
    }

    let banner = $('.notification-banner:not(.zondag-banner)');
    let startDate = new Date(banner.data('start-date'));
    let endDate = new Date(banner.data('end-date'));
    let currentDate = new Date();

    // Check if the current date is between startDate and endDate
    if (currentDate >= startDate && currentDate <= endDate) {
        banner.addClass('active');
    }

    $('.notification-banner__close').on('click', function() {
        $(this).closest('.notification-banner').removeClass('active');
    });
});